import { render, staticRenderFns } from "./LinkManList.vue?vue&type=template&id=aab42514&scoped=true"
import script from "./LinkManList.vue?vue&type=script&lang=js"
export * from "./LinkManList.vue?vue&type=script&lang=js"
import style0 from "./LinkManList.vue?vue&type=style&index=0&id=aab42514&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab42514",
  null
  
)

export default component.exports